import { useQuery } from '@apollo/client';

import GetSpecializationBySlugForPromotionBanner from 'bundles/promotions/queries/GetSpecializationBySlugForPromotionBannerQuery.graphql';
import type {
  GetSpecializationBySlugForPromotionBannerQuery,
  GetSpecializationBySlugForPromotionBannerQueryVariables,
} from 'bundles/promotions/queries/__generated__/GetSpecializationBySlugForPromotionBannerQuery';

export type PropsFromUseGetSpecializationBySlug = {
  s12n?: {
    id: string;
    courseIds: string[];
  };
};

export const useGetSpecializationBySlug = (s12nSlug?: string) => {
  const { data } = useQuery<
    GetSpecializationBySlugForPromotionBannerQuery,
    GetSpecializationBySlugForPromotionBannerQueryVariables
  >(GetSpecializationBySlugForPromotionBanner, {
    variables: { slug: `${s12nSlug}` },
    skip: !s12nSlug,
    context: { clientName: 'gatewayGql' },
  });

  const s12nData = data?.Specialization?.queryBySlug;

  if (!s12nData) {
    return {};
  }

  const s12n = {
    id: s12nData.id,
    courseIds: s12nData.courses.map(({ id }) => id),
  };

  return {
    s12n,
  };
};
